import NWSAlertsList from './displays/NWSAlertsList';

export default function NWSAlerts({ localAlerts, title }) {
  const date = new Date().toLocaleDateString();

  return (
    <div className="flex-column h-100 w-100 overflow-hidden">
      <div className="fs-4 fw-bold flex-grow-0 w-100 border-bottom border-light-subtle border-1">
        {date} {title}
      </div>
      <div className="flex-column h-100 w-100 overflow-y-auto">
        <NWSAlertsList localAlerts={localAlerts} />
      </div>
    </div>
  );
}
